import { useMemo } from 'react';

import { useKnownAvailableParams } from '@change-corgi/core-react/router';

import { useStartAPetitionPageState } from '#src/app/pages/startAPetitionV2/pageContext';
import { useQueryParamValue } from '#src/app/shared/hooks/location';
import { useTrackView } from '#src/app/shared/hooks/tracking';

import { replaceAllValuesWithTrueRecord } from './utils';

export function useTrackPageView(): void {
	const { step } = useKnownAvailableParams<{ step: string }>();
	const { data } = useStartAPetitionPageState();
	const loginMethod = data.draft?.metadata?.user?.loginOrJoinMethod;
	const sourceLocation = useQueryParamValue('source_location');

	const formattedStep = useMemo(() => step.replace(/-/g, '_').toLowerCase(), [step]);
	const draftData = replaceAllValuesWithTrueRecord(data.draft ?? {});

	useTrackView(`sap_${formattedStep}_view`, {
		login_method: loginMethod,
		draft: draftData,
		source_location: sourceLocation,
	});
}
